<template>
  <div id="jumbotron">
    <div class="container">
      <h1 v-html="$t('englishAdultPage.title')"></h1>
    </div>
  </div>

  <div class="container pt-5">
    <div class="row m-0">
      <div class="col-12 col-md-4 col-lg-3">
        <h2 class="text-primary mb-4">
          {{ $t('englishAdultPage.courseStructure.title') }}
        </h2>
      </div>
      <div class="col-12 col-md-8 col-lg-9">
        <div v-html="$t('englishAdultPage.courseStructure.description')"></div>

        <ul v-html="$t('englishAdultPage.courseStructure.points')"></ul>

        <p v-html="$t('englishAdultPage.courseStructure.cta')"></p>

        <div id="classPhotos" class="row m-0 mt-5">
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-1.webp" alt="English Class for Adults" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-2.webp" alt="English Class for Adults" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-3.webp" alt="English Class for Adults" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/Classes+Adults-4.webp" alt="English Class for Adults" class="w-100 rounded"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-color py-5 mt-5">
    <div class="container">
      <div class="row m-0">
        <div class="col-12 col-md-3 col-lg-3">
          <h2 class="text-primary mb-4">
            {{ $t('englishAdultPage.corporateSolution.title') }}
          </h2>
        </div>
        <div class="col-12 col-md-7 col-lg-7">
          <ul>
            <li>{{ $t('englishAdultPage.corporateSolution.description[0]') }}</li>
            <li v-html="$t('englishAdultPage.corporateSolution.description[1]')"></li>
            <li v-html="$t('englishAdultPage.corporateSolution.description[2]')"></li>
          </ul>
        </div>
        <div class="col-12 col-md-2 col-lg-2 text-center text-md-end">
          <img id="hrdfLogo" src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_adult/hrdcorp-trainer.webp" alt="Classes are HRDF Claimable" class="w-100">
        </div>
      </div>
    </div>
  </div>

  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; }

.bg-color {
  background-color: #F4F3F9;
}

#classPhotos img {
  max-width: 225px;
  height: auto;
  object-fit: cover; 
  aspect-ratio: 1 / 1;
  margin-bottom: 20px;
}

li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

#hrdfLogo {
  max-width: 200px;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>